import { isIOS, isSafari } from 'react-device-detect';
import Banner from 'assets/photo/worksheet-maker/header/banner.png';
import Border from 'assets/photo/worksheet-maker/border.png';
import { Typography, Box } from '@mui/material';

const LandscapeCompletionBorder = ({ children, title }: any) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        ...(isIOS || isSafari ? { '@media print': { marginTop: '-10px' } } : {})
      }}
    >
      <Typography
        variant="h1"
        align="center"
        sx={{
          fontSize: '36px',
          fontWeight: 'bold',
          marginTop: '-29px',
          ...(isIOS || isSafari ? { '@media print': { marginTop: '0px' } } : {})
        }}
        id="bannerTitle"
      >
        {title}
      </Typography>

      <img
        alt=""
        id="completionBanner"
        style={{
          position: 'absolute',
          alignSelf: 'center',
          top: '24px',
          marginLeft: '-2px',
          width: '758px',
          height: '100px'
        }}
        src={Banner}
      />
      <img
        alt=""
        style={{
          display: 'flex',
          alignSelf: 'center',
          width: '997px',
          height: '700px'
        }}
        src={Border}
      />
      <Box
        sx={{
          height: '600px',
          display: 'flex',
          flexDirection: 'column',
          alignSelf: 'center',
          top: '200px',
          position: 'absolute',
          justifyContent: 'space-evenly',
          marginTop: '-15px'
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default LandscapeCompletionBorder;
